<template>
  <div class="breadcrumb">
    <router-link :to="originPath">{{ originName }}</router-link> / <router-link v-if="additionalName" :to="additionalPath">{{ additionalName }}</router-link> {{ additionalName ? "/" : "" }} <span>{{ currentName }}</span>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    originName: String,
    originPath: String,
    additionalName: String,
    additionalPath: String,
    currentName: String,
  },
};
</script>

<style lang="scss" scoped>
  .breadcrumb {
    background-color: #F5F5F5;
    padding: 7px 15px;
    display: flex;
    gap: 7px;
    color: #CCCCCC;
    border-radius: 4px;
    > span {
      color: #787878;
    }
  }
</style>
